import { render, staticRenderFns } from "./NoDataOverlayIndicadores.vue?vue&type=template&id=284eedfa&scoped=true&"
import script from "./NoDataOverlayIndicadores.vue?vue&type=script&lang=js&"
export * from "./NoDataOverlayIndicadores.vue?vue&type=script&lang=js&"
import style0 from "./NoDataOverlayIndicadores.vue?vue&type=style&index=0&id=284eedfa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284eedfa",
  null
  
)

export default component.exports